// 2026-07-25:旧 MediaPage 改名 MediaDemoPage,迁到 /media-demo。
// 所有交互保留「alert("現在はデモ機能です")」,mock 数据原样不动。
// 正式 /media 页(MediaPage.tsx)由真实 WordPress Media Library 驱动。
import { useState } from "react";
import { Search, Upload, FolderClosed, Image as ImageIcon, FileText, Video, Plus, Grid3x3, List } from "lucide-react";
import { Card } from "../../components/ui/Card";
import { Button } from "../../components/ui/Button";
import { mediaItems, folders } from "./mock";

/**
 * メディアライブラリページ(Demo 版)
 *
 * /media-demo 配下のみ表示される旧 Mock UI。
 * 正式 /media(MediaPage.tsx)は WordPress Media Library を直接操作する。
 */
export const MediaDemoPage = () => {
  const [activeFolder, setActiveFolder] = useState("all");

  return (
    <div className="media-shell">
      {/* 左: フォルダ */}
      <Card>
        <div className="card-title" style={{ marginBottom: 12 }}>
          フォルダ
        </div>
        <div>
          {folders.map((f) => (
            <div
              key={f.value}
              className={`folder-item ${activeFolder === f.value ? "active" : ""}`}
              onClick={() => setActiveFolder(f.value)}
            >
              <FolderClosed size={14} />
              <span>{f.label}</span>
              <span className="folder-item-count">{f.count}</span>
            </div>
          ))}
        </div>
        <hr className="divider" />
        <Button full variant="secondary" iconLeft={<Plus size={14} />}>
          フォルダを追加
        </Button>

        <hr className="divider" />

        <div style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", marginBottom: 10 }}>
          ストレージ使用量
        </div>
        <div className="progress mb-12">
          <div className="progress-bar" style={{ width: "48%" }} />
        </div>
        <div style={{ fontSize: 12, color: "#374151", marginBottom: 4 }}>
          <strong style={{ color: "#111827" }}>48 GB</strong> / 100 GB 使用中
        </div>
        <div style={{ fontSize: 11, color: "#94a3b8" }}>合計 246 ファイル</div>
      </Card>

      {/* 右: メディアエリア */}
      <Card>
        <div className="row-between mb-18">
          <div className="row gap-8">
            <div className="input-with-icon" style={{ width: 280 }}>
              <span className="input-icon">
                <Search size={14} />
              </span>
              <input className="input" placeholder="ファイル名で検索..." />
            </div>
            <select className="select" style={{ width: 140 }} defaultValue="all">
              <option value="all">全タイプ</option>
              <option value="image">画像</option>
              <option value="video">動画</option>
              <option value="doc">ドキュメント</option>
            </select>
            <select className="select" style={{ width: 130 }} defaultValue="newest">
              <option value="newest">新しい順</option>
              <option value="oldest">古い順</option>
              <option value="name">名前順</option>
              <option value="size">サイズ順</option>
            </select>
          </div>

          <div className="row gap-8">
            <button className="btn-icon" onClick={() => alert("現在はデモ機能です")} title="グリッド">
              <Grid3x3 size={16} />
            </button>
            <button className="btn-icon" onClick={() => alert("現在はデモ機能です")} title="リスト">
              <List size={16} />
            </button>
            <Button iconLeft={<Upload size={14} />}>アップロード</Button>
          </div>
        </div>

        <div className="media-grid">
          {mediaItems.map((m) => (
            <div key={m.id} className="media-card" onClick={() => alert("現在はデモ機能です")}>
              <div className="media-thumb" style={{ background: m.gradient }}>
                {m.type === "image" && <ImageIcon size={32} color="rgba(255,255,255,0.85)" />}
                {m.type === "document" && <FileText size={32} color="rgba(255,255,255,0.85)" />}
                {m.type === "video" && <Video size={32} color="rgba(255,255,255,0.85)" />}
                <span
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    background: "rgba(15,23,42,0.7)",
                    color: "#fff",
                    fontSize: 10,
                    fontWeight: 700,
                    padding: "2px 6px",
                    borderRadius: 6,
                  }}
                >
                  {m.ext}
                </span>
              </div>
              <div className="media-info">
                <div className="media-name">{m.name}</div>
                <div className="media-meta">
                  <span>{m.date}</span>
                  <span>{m.size}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};